import React, { FC, useEffect, useRef, useState } from 'react'

interface SectionWrapperProps {
	title: string
	children: React.ReactNode
	id?: string
	removeShadow?: boolean
	isMiniGamesSection?: boolean
	width?: number
}

const SectionWrapper: FC<SectionWrapperProps> = ({ title, children, isMiniGamesSection = false, id, removeShadow = false, width = null }) => {
	const [canScroll, setCanScroll] = useState(false)
	const [atStart, setAtStart] = useState(true)
	const [atEnd, setAtEnd] = useState(false)

	const [isDragging, setIsDragging] = useState(false)
	const [startX, setStartX] = useState(0)
	const [scrollLeft, setScrollLeft] = useState(0)

	const [showLeftFade, setShowLeftFade] = useState(false)
	const [showRightFade, setShowRightFade] = useState(true)
	const carouselRef = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		const handleScroll = () => {
			if (carouselRef.current) {
				const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current
				setShowLeftFade(scrollLeft > 0)
				setShowRightFade(scrollLeft < scrollWidth - clientWidth)
			}
		}

		const carousel = carouselRef.current
		if (carousel) {
			carousel.addEventListener('scroll', handleScroll)
		}

		return () => {
			if (carousel) {
				carousel.removeEventListener('scroll', handleScroll)
			}
		}
	}, [])

	useEffect(() => {
		const carousel = carouselRef.current
		if (carousel) {
			const { scrollWidth, clientWidth } = carousel
			setCanScroll(scrollWidth > clientWidth)
			setAtStart(carousel.scrollLeft === 0)
			setAtEnd(carousel.scrollLeft + clientWidth >= scrollWidth - 1)
		}
	}, [children])
	useEffect(() => {
		const carousel = carouselRef.current
		if (carousel) {
			const { scrollWidth, clientWidth } = carousel
			setCanScroll(scrollWidth > clientWidth)
			setAtStart(carousel.scrollLeft === 0)
			setAtEnd(carousel.scrollLeft + clientWidth >= scrollWidth - 1)
		}
	}, [children])

	useEffect(() => {
		const carousel = carouselRef.current
		if (carousel) {
			const handleScroll = () => {
				const { scrollLeft, scrollWidth, clientWidth } = carousel
				setAtStart(scrollLeft === 0)
				setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1)
			}
			carousel.addEventListener('scroll', handleScroll)
			return () => {
				carousel.removeEventListener('scroll', handleScroll)
			}
		}
	}, [])
	useEffect(() => {
		const carousel = carouselRef.current
		if (carousel) {
			const handleScroll = () => {
				const { scrollLeft, scrollWidth, clientWidth } = carousel
				setAtStart(scrollLeft === 0)
				setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1)
			}
			carousel.addEventListener('scroll', handleScroll)
			return () => {
				carousel.removeEventListener('scroll', handleScroll)
			}
		}
	}, [])

	const handleNext = () => {
		const carousel = carouselRef.current
		if (carousel && canScroll && !atEnd) {
			const { clientWidth } = carousel
			carousel.scrollBy({
				left: width ? width - 12 : clientWidth + 12,
				behavior: 'smooth',
			})
		}
	}

	const handlePrev = () => {
		const carousel = carouselRef.current
		if (carousel && canScroll && !atStart) {
			const { clientWidth } = carousel
			carousel.scrollBy({
				left: width ? -width + 12 : -clientWidth - 12,
				behavior: 'smooth',
			})
		}
	}

	const onDragStart = (e: React.MouseEvent) => {
		setIsDragging(true)
		if (carouselRef.current) {
			setStartX(e.pageX - carouselRef.current.offsetLeft)
			setScrollLeft(carouselRef.current.scrollLeft)
		}
	}

	const onDragEnd = () => {
		setIsDragging(false)
	}

	const onDragMove = (e: React.MouseEvent) => {
		if (!isDragging) return
		e.preventDefault()
		if (carouselRef.current) {
			const x = e.pageX - carouselRef.current.offsetLeft
			const walk = (x - startX) * 1.5
			carouselRef.current.scrollLeft = scrollLeft - walk
		}
	}

	return (
		<div className="section-wrapper" id={id}>
			<div className="section-header">
				<div className="section-name">{title}</div>
				<div className="section-nav">
					<div
						className={`arrow-left ${!canScroll || atStart ? 'disabled' : ''}`}
						onClick={handlePrev}
						style={{ opacity: !canScroll || atStart ? 0.5 : 1, pointerEvents: !canScroll || atStart ? 'none' : 'auto' }}
					></div>
					<div
						className={`arrow-right ${!canScroll || atEnd ? 'disabled' : ''}`}
						onClick={handleNext}
						style={{ opacity: !canScroll || atEnd ? 0.5 : 1, pointerEvents: !canScroll || atEnd ? 'none' : 'auto' }}
					></div>
				</div>
			</div>
			<div className="carousel-container">
				{showLeftFade && !removeShadow && (
					<div
						className="fade-overlay fade-left"
						style={{
							background: `${
								isMiniGamesSection ? 'linear-gradient(to right, rgba(39, 36, 79, 1), rgba(39, 36, 79, 0))' : 'linear-gradient(to right, rgba(27, 25, 62, 1), rgba(27, 25, 62, 0))'
							}`,
						}}
					></div>
				)}
				{showRightFade && !removeShadow && (
					<div
						className="fade-overlay fade-right"
						style={{
							background: `${
								isMiniGamesSection ? 'linear-gradient(to right, rgba(39, 36, 79, 0), rgba(39, 36, 79, 1))' : 'linear-gradient(to right, rgba(27, 25, 62, 0), rgba(27, 25, 62, 1))'
							}`,
						}}
					></div>
				)}
				<div
					className="cards-wrapper"
					onMouseDown={onDragStart}
					onMouseLeave={onDragEnd}
					onMouseUp={onDragEnd}
					onMouseMove={onDragMove}
					ref={carouselRef}
					style={{ overflowX: 'auto', display: 'flex'}}
				>
					{children}
				</div>
			</div>
		</div>
	)
}

export default SectionWrapper
